import { createContext } from "react";
export const StopEventContext = createContext(null);
